import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import { scrollToTop } from "../Shared/ScrollOnTop";
import StudentPanelMenu from "./StudentPanelMenu";
import StudentRightsCheck from "./StudentRightsCheck";

function Parent_Change_Password() {
  const [parentRoleLabel, setParentRoleLabel] = useState("");
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password1, setPassword1] = useState(null);
  const [password2, setPassword2] = useState(null);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Parent portal — change password";
    const role = (localStorage.getItem("ParentPortalRole") || "").trim();
    if (role === "Father") setParentRoleLabel("Father");
    else if (role === "Mother") setParentRoleLabel("Mother");
    else setParentRoleLabel("Parent");
  }, []);

  const parentProof =
    typeof window !== "undefined" ? localStorage.getItem("ParentPortalProof") : "";
  if (!parentProof) {
    return <Navigate to="/student-panel/change-password" replace />;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (password1 != password2) {
      toast.error("New password and confirmation do not match.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setLoading(true);
      const data = {
        ParentProof: localStorage.getItem("ParentPortalProof"),
        OldPassword: form.txtOldPassword.value,
        NewPassword: form.txtNewPassword.value,
      };

      axios({
        method: "post",
        url: config.base_url + "Student/ParentChangePassword",
        headers: { "Content-Type": "application/json" },
        data,
      })
        .then(function (response) {
          if (response.data.status_code === 1) {
            localStorage.setItem("ParentPortalProof", response.data.ParentProof || "");
            localStorage.setItem(
              "ParentPortalChildren",
              JSON.stringify(response.data.ListOfChildren || [])
            );
            localStorage.setItem(
              "ParentPortalRole",
              response.data.ParentRole || localStorage.getItem("ParentPortalRole") || ""
            );
            toast.success(response.data.status_message || "Password updated.", {
              position: toast.POSITION.TOP_RIGHT,
            });
            navigate("/student-panel/dashboard");
          } else {
            toast.error(response.data.status_message || "Could not update password.", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          setLoading(false);
        })
        .catch(function () {
          setLoading(false);
          toast.error("Network error.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }

    setValidated(true);
  };

  return (
    <>
      <StudentPanelMenu />
      <ToastContainer />
      <StudentRightsCheck />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink onClick={scrollToTop} to="/student-panel/dashboard">
                        Home
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Parent portal password
                    </li>
                  </ol>
                </nav>
                <div className="page-title">Change parent portal password</div>
                <p className="text-muted small mb-0">
                  Signed in as <strong>{parentRoleLabel}</strong>. This updates the portal password
                  for your mobile on all linked students (same as admission / profile).
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <Form
                      noValidate
                      validated={validated}
                      onSubmit={handleSubmit}
                    >
                      <div className="row align-items-end">
                        <div className="col-md-3">
                          <div className="form-group mb-3 position-relative">
                            <label>Current password</label>
                            <input
                              type={showPassword1 ? "text" : "password"}
                              className="form-control"
                              required
                              name="txtOldPassword"
                              autoComplete="current-password"
                            />
                            <span
                              className={`${showPassword1 ? "ri-eye-off-line" : "ri-eye-line"}`}
                              onClick={() => setShowPassword1(!showPassword1)}
                              style={{
                                position: "absolute",
                                bottom: "6px",
                                right: "12px",
                                cursor: "pointer",
                              }}
                              role="button"
                              tabIndex={0}
                              aria-label="Toggle visibility"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-3 position-relative">
                            <label>New password</label>
                            <input
                              type={showPassword2 ? "text" : "password"}
                              className="form-control"
                              required
                              name="txtNewPassword"
                              autoComplete="new-password"
                              onChange={(e) => setPassword1(e.target.value)}
                            />
                            <span
                              className={`${showPassword2 ? "ri-eye-off-line" : "ri-eye-line"}`}
                              style={{
                                position: "absolute",
                                bottom: "6px",
                                right: "12px",
                                cursor: "pointer",
                              }}
                              onClick={() => setShowPassword2(!showPassword2)}
                              role="button"
                              tabIndex={0}
                              aria-label="Toggle visibility"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group mb-3 position-relative">
                            <label>Confirm new password</label>
                            <input
                              type={showPassword3 ? "text" : "password"}
                              className="form-control"
                              required
                              name="txtRePassword"
                              autoComplete="new-password"
                              onChange={(e) => setPassword2(e.target.value)}
                            />
                            <span
                              className={`${showPassword3 ? "ri-eye-off-line" : "ri-eye-line"}`}
                              style={{
                                position: "absolute",
                                bottom: "6px",
                                right: "12px",
                                cursor: "pointer",
                              }}
                              onClick={() => setShowPassword3(!showPassword3)}
                              role="button"
                              tabIndex={0}
                              aria-label="Toggle visibility"
                            />
                          </div>
                        </div>
                        <div className="col-md-3 text-end">
                          <div className="form-group mb-3">
                            {loading ? (
                              <Spinner animation="border" role="status" />
                            ) : (
                              <button
                                type="submit"
                                className="button button-primary"
                              >
                                Update password
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Parent_Change_Password;
